import { put, call, takeEvery } from 'typed-redux-saga';
import AdminGateway from '~apis/admin';

import combinedActions from '~redux/combinedActions';
import { store } from '~redux/store';

import { GatewayResponseStatus } from '~types/gateway';
import { SagaWatcherReturnType } from '~types/saga';

import { ErrorMessages } from '~utils/constants';

export default function* watchExportAdminUserListing(api: AdminGateway): SagaWatcherReturnType {
    yield takeEvery('admin/adminExportAdminUserListingAttempt', handleExportAdminUserListing, api);
}

function* handleExportAdminUserListing(api: AdminGateway) {
    const reduxState = store.getState();
    const authToken = reduxState.auth.userDetails.authToken;

    const response = yield* call([api, api.exportAdminUserListing], { authToken });

    if (response.status === GatewayResponseStatus.Error) {
        yield put(combinedActions.adminExportAdminUserListingFailure(response.message || ErrorMessages.GenericError));
        return;
    }

    if (response.status === GatewayResponseStatus.Success) {
        yield put(combinedActions.adminExportAdminUserListingSuccess(response.data));
    }
}
